import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import ServicesListItem from "./ServicesListItem";

const ServicesListTable = (props) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead color="primary">
          <TableRow>
            <TableCell>Proyecto</TableCell>
            <TableCell>Servicio</TableCell>
            <TableCell align="center">Scheduler</TableCell>
            <TableCell align="center">Auto Aprobación</TableCell>
            <TableCell align="center">Email Admin</TableCell>
            {/* <TableCell align="center">Email Asociado</TableCell> */}
            <TableCell align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.projects?.map((project) => (
            <ServicesListItem
              key={project._id}
              project={project}
              onRefresh={props.onRefresh}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServicesListTable;
